<section
  id="login-back"
  class="inner-section"
>
  <img
    src="@/assets/images/logo.png"
    alt=""
    id="logo"
    class="energy2go-logo"
  />
  <h3
    class="subtitle text-uppercase"
    v-text="$t('login.title_rent')"
  ></h3>
  <div
    id="login-div"
    class="py-2 blue-background"
  >
    <div>
      <h3
        class="navbar-text"
        v-text="$t('login.sign_in')"
      ></h3>
      <div class="social-login">
        <GoogleLogin
          :button-config="{ size: 'large', width: '270'}"
          :callback="callback"
          one-tap="false"
          prompt
        />
        <HFaceBookLogin
          class="btn-facebook"
          v-slot="fbLogin"
          app-id="{{ import.meta.env.VITE_FACEBOOK_ID }}"
          @onSuccess="onFacebookSignInSuccess"
          @onFailure="onFacebookError"
          scope="email,public_profile"
          fields="id,name,email"
        >
          <div class="floating-box inline-block">
            <img
              alt="facebook"
              class="btn-facebook-img"
              :src="fb_icon"
            />
          </div>
          <div class="floating-box inline-block-sb">
            <span
              @click="fbLogin.initFBLogin"
              id="facebook_registration_button"
              class="btn-facebook-text"
            >
              {{ $t('login.facebook_btn_text') }}
            </span>
          </div>
        </HFaceBookLogin>
      </div>
    </div>
    <div
      class="mt-2 clearfix"
      id="account-options-email"
    >
      <p
        id="sign_up_link"
        class="register-account text-center mt-1"
      >
        <router-link
          to="/sign-up"
          v-text="$t('login.register_with_email')"
        ></router-link>
      </p>
      <p
        id="user_terms_link"
        class="register-account text-center mt-2"
      >
        <a
          class="terms-link"
          href="./policy.html"
          target="_blank"
          v-text="$t('sign_up.user_terms')"
        ></a>
      </p>
    </div>
  </div>

  <!-- Footer Section with Price Info and Links -->
  <div class="mt-3">
    <div
      v-if="showPrice"
      class="m-4 text-center price-info"
    >
      {{ rentInfoText }}
    </div>

    <div class="footer-links">
      <a
        href="#"
        v-on:click.prevent="handleShowPriceTableModal(true)"
      >
        <font-awesome-icon
          icon="fa-solid fa-money-bill-alt"
          class="btn-icon-map"
        />
        <span>{{ $t('home.take.price_table') }}</span>
      </a>
    </div>

    <div class="footer-links">
      <router-link :to="{ path: `maps` }">
        <font-awesome-icon
          icon="fa-solid fa-map-location-dot"
          class="btn-icon-map"
        />
        <span>{{ $t('login.find_us') }}</span>
      </router-link>
    </div>
  </div>

  <PriceTableModal
    v-if="showPriceTableModal"
    :showPriceTableModal="showPriceTableModal"
    @hidePriceTableModal="handleShowPriceTableModal(false)"
  ></PriceTableModal>

  <AppVersion class="app-version" />

  <a
    :href="$t('login.whatsapp_msg')"
    target="_blank"
  >
    <font-awesome-icon
      class="whatsapp-icon-fixed"
      :icon="{ prefix: 'fab', iconName: 'whatsapp' }"
      size="2x"
    />
  </a>
</section>
